import { Modal, Button, DatePicker } from "antd";
import React, { useState } from "react";
import { LoadingConfig } from "../../../components";
import moment from "moment";
import {
  handleStatus,
  numberWithCommas,
  PROD_LOCATION,
} from "../../../constants";
import { useDispatch } from "react-redux";
import { updateTimeOrderAction } from "../../../appRedux/action/OrderAction";
const ModalItem = (props) => {
  const { handleClose, data, invisibleModal } = props;
  const dispatch = useDispatch();
  // console.log(data, "dataModal");

  const [loading, setLoading] = useState(false);
  const [newDate, setNewDate] = useState(0);
  // console.log("date", newDate);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("AUTH_INFO")) || ""
  );
  const handleCloseModal = () => {
    if (handleClose) {
      handleClose(false);
    }
  };

  const handleUpdate = async () => {
    const dataNew = { id: data?._id, booking_date: newDate };
    console.log(moment(data?.booking_date_timestamp).unix());
    // console.log("aaaaa", dataNew);
    if (newDate && newDate !== moment(data?.booking_date_timestamp).unix()) {
      // console.log("sssss", dataNew);
      await dispatch(updateTimeOrderAction(dataNew));
      handleCloseModal();
    } else {
      handleCloseModal();
    }
  };

  const handleTimeNew = (date, dateString) => {
    setNewDate(moment(date).unix());
  };
  // console.log(newDate);
  const disabledDate = (current) => {
    return current < moment().add(3, "day");
  };
  return (
    <Modal
      title="Đổi ngày tiêm"
      visible={invisibleModal}
      onOk={handleCloseModal}
      onCancel={handleCloseModal}
      width={900}
      className="modalUpdateDay"
      footer={[
        <Button
          key="back"
          type="back"
          loading={loading}
          onClick={handleCloseModal}
        >
          Hủy
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleUpdate}
          disabled={data?.status !== 0 && data?.status !== 1 ? true : false}
        >
          Xác nhận đổi
        </Button>,
      ]}
    >
      {loading && <LoadingConfig title="" />}
      <div className="row">
        <div className="col-6 box__label ">Người đăng kí : </div>
        <div className="col-6 box__content ">{data ? data?.name : "-"}</div>
        <div className="col-6 box__label ">Số điện thoại :</div>
        <div className="col-6 box__content ">
          {userInfo ? userInfo.phone_number : ""}
        </div>
        <div className="col-6 box__label ">Email :</div>
        <div className="col-6 box__content ">
          {" "}
          {userInfo ? userInfo.email : ""}
        </div>

        <div className="col-6 box__label ">Địa chỉ người dùng :</div>
        <div className="col-6 box__content ">
          {" "}
          {userInfo ? userInfo.address : ""}
        </div>

        <div className="col-6 box__label ">Mã đăng kí :</div>
        <div className="col-6 box__content ">
          {data ? data?.code_note : "-"}
        </div>
        <div className="col-6 box__label ">Loại vaccine :</div>
        <div className="col-6 box__content ">
          {data ? (data?.group === "special" ? "Đặc biệt" : "Thường") : "-"}
        </div>
        <div className="col-6 box__label ">Phòng bênh tương ứng :</div>
        <div className="col-6 box__content ">{data ? data?.pathogen : "-"}</div>
        <div className="col-6 box__label ">Ngày đăng ký tiêm :</div>
        <div className="col-6 box__content ">
          {data
            ? moment.unix(data.booking_date_timestamp).format("DD/MM/YYYY")
            : "-"}
        </div>

        <div className="col-6 box__label ">Ngày bạn muốn thay đổi :</div>
        <div className="col-6 box__content ">
          <DatePicker
            disabled={data?.status !== 0 && data?.status !== 1 ? true : false}
            onChange={handleTimeNew}
            format="DD/MM/YYYY"
            style={{ width: "100%" }}
            placeholder="Ngày sinh định dạng 25/03/2021 (*)"
            disabledDate={disabledDate}
          />
        </div>
        <div className="col-6 box__label ">Trạng thái :</div>
        <div className="col-6 box__content ">
          {data ? handleStatus(data?.status) : "-"}
        </div>

        <div className="col-6 box__label ">Ngày cơ sơ tiêm xác nhận :</div>
        <div className="col-6 box__content ">
          {data && data?.confirm_date_timestamp !== 0
            ? moment.unix(data?.confirm_date_timestamp).format("DD/MM/YYYY")
            : "-"}
        </div>
        {/* <div className="col-6 box__label ">Giá trị thanh toán </div>
        <div className="col-6 box__content ">
          {data
            ? data.amount === 0
              ? "-"
              : `${numberWithCommas(data.amount || 0)} VNĐ`
            : "-"}
        </div> */}

        <div className="col-6 box__label ">Cơ sở phòng tiêm đăng ký :</div>
        <div className="col-6 box__content ">
          <div className="info-location">
            <span className="first">{data ? data?.location?.name : "-"}</span>
            <br />
            <span>{data ? "ĐC : " + data?.location?.description : "-"}</span>
            <br />
            <span>{data ? "ĐT : " + data?.location?.phone_number : "-"}</span>
            <br />
            <span>
              {data ? (
                <>
                  Email: <a href="#"> {data ? data?.location?.email : "-"}</a>{" "}
                  <br />
                  Website: www.{PROD_LOCATION}.com
                </>
              ) : (
                ""
              )}
            </span>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalItem;
